import cn from 'classnames';
import { AdminListCheckbox } from '../AdminListCheckbox';
import { AdminListHeaderCell } from '../AdminListHeaderCell';
import { StyledAdminDeviceGroupsListHeader } from './styles';
import { useTranslation } from 'react-i18next';
import { TSortAdminDeviceGroupByHeaderTitle } from 'types';

interface IDeviceGroupsListHeaderProps {
  children?: React.ReactNode;
  onSelectAll: (selected: boolean) => void;
  selectedAll?: boolean;
}

type FieldType = {
  key: TSortAdminDeviceGroupByHeaderTitle;
};

export const headerFields: FieldType[] = [
  { key: 'name' },
  { key: 'normalHashrate' },
  { key: 'adjust' },
  { key: 'yesterdayHashrate' },
  { key: 'payment' },
];

export const AdminDeviceGroupsListHeader = ({
  onSelectAll,
  selectedAll,
}: IDeviceGroupsListHeaderProps) => {
  const { t } = useTranslation();

  const selectRowHandler = () => {
    onSelectAll(!selectedAll);
  };

  return (
    <StyledAdminDeviceGroupsListHeader>
      <div className="admin-list-header-cell-container select">
        <AdminListCheckbox checked={selectedAll} onChange={selectRowHandler} />
      </div>
      {headerFields.map(({ key }) => (
        <div key={key} className={cn('admin-list-header-cell-container', key.toLowerCase())}>
          <AdminListHeaderCell fieldKey={key}>
            {t(`adminPage.editDeviceGroups.listHeaders.${key}`)}
          </AdminListHeaderCell>
        </div>
      ))}
    </StyledAdminDeviceGroupsListHeader>
  );
};
